module.exports = __webpack_public_path__ + "img/platform2.3eb95217.png";